export default function(instance){
    return{
        Add(payload){
            return instance.put("/CompanyPlan/Add", payload);
        },
        DeleteRange(payload){
            return instance.delete("/CompanyPlan/DeleteRange", payload);
        },
        Update(payload){
            return instance.post("/CompanyPlan/Update", payload);
        },
    }
}
